import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';

export function WixInstructions({ techOptions = [], selectedTechOption = null, onSelectTech, onContactDeveloper }) {
  const [accSegment1, accSegment2] = useAccountNumber(true);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>
          Within your Wix dashboard, click on <strong>Settings</strong> in the left navigation.
        </ListItem>

        <ListItem number={2}>
          Scroll down to the <strong>Advanced Settings</strong> section and click on <strong>Custom Code.</strong>
        </ListItem>

        <ListItem number={3}>
          In the <strong>top right-hand corner</strong>, click ‘+<strong>Add Custom Code</strong>’.
        </ListItem>

        <ListItem number={4}>Copy and paste the Crazy Egg tracking script below into the input field.</ListItem>
      </ol>

      <CodeSnippet
        code={`<script type="text/javascript" src="//script.crazyegg.com/pages/scripts/${accSegment1}/${accSegment2}.js" async="async"></script>`}
        showMailButton
        onMailButtonClick={onContactDeveloper}
      />

      <ol className="flex flex-col gap-4 mt-4">
        <ListItem number={5}>
          Select <strong>Load code on each new page.</strong>
        </ListItem>

        <ListItem number={6}>
          Select <strong>Place Code in Head.</strong>
        </ListItem>

        <ListItem number={7}>
          Click on <strong>Apply.</strong>
        </ListItem>
      </ol>

      <div className="flex flex-col gap-1 mt-5">
        <SupportLink
          href={SupportLinks.install.wix}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Wix Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have connected Crazy Egg with Wix.
      </p>
    </Card>
  );
}
